

import { loadStyle } from './utils';

const fonts = {
  // tagesspiegel
  franklin: 'https://interaktiv.tagesspiegel.de/lab/assets/fonts/franklin_gothic_fs_v3.css',
  abril: 'https://interaktiv.tagesspiegel.de/lab/assets/fonts/abril.css',
  // other
  roboto: `${PATH}fonts/roboto.css`,
  pt_serif: `${PATH}fonts/pt_serif.css`,
  public_sans: `${PATH}fonts/public_sans.css`,
  proxima_nova: `${PATH}fonts/proxima_nova.css`,
  inter: `${PATH}fonts/inter.css`,
};

const fontThemes = {
  tagesspiegel: { fonts: ['franklin', 'abril'] },
  roboto: { fonts: ['roboto'] },
  pt_serif: { fonts: ['pt_serif'] },
  investigate_europe: { fonts: ['public_sans'] },
  meduza: { fonts: ['proxima_nova'] },
  bergens: { fonts: ['inter'] },
};

export function setFontTheme(theme, noAssets) {
  if (!noAssets) {
    fontThemes[theme].fonts.forEach((f) => {
      loadStyle(fonts[f]);
    });
  }
  Object.keys(fontThemes).forEach((ft) => {
    document.documentElement.classList.remove(`tsg-fonts-${ft}`);
  });
  document.documentElement.classList.add(`tsg-fonts-${theme}`);
}
